import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { IntlService } from '@progress/kendo-angular-intl';
import {
  Ultil_donvi
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-quantri-donviedit',
  templateUrl: './donviedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./donviedit.component.scss'],
  providers: [ListService, Repository]
})


export class donvisudungeditComponent implements OnInit {


  @ViewChild('dteChung') doituongchungedit: any;
  @ViewChild('slTaiKhoanNH') slTaiKhoanNH: any;
  @ViewChild('inputTenKB') inputTenKB: any;

  inputlienthongs: any = [
    { Id: 0, Ten: 'Không liên thông nội bộ' },
    { Id: 1, Ten: 'Liên thông nội bộ' }
  ];

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

  inputparents: any;
  inputVungs: any;
  inputCapDonVis: any;
  currentUser: any;

  public formatDatetn = 'dd/MM/yyyy';
  public formatDatedn = 'dd/MM/yyyy';
  donviid: any;
  tabselected: number = 1;

  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Ma: null, Ten: null, DiaChi: null, DienThoai: null, Email: null, MaAo: null,
    CapTrenId: null, TenTiengNuocNgoai: null, SapXep: null
    , Created: null, CreatedBy: null, Modified: null, ModifiedBy: null
    , VungId: null, ThuocCap: null, NgayThanhLap_S: null, NgayGiaiThe_S: null, NgayGiaiThe: null, NgayThanhLap: null
  };   
  nhomdtid: string = null;


  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, public repo: Repository, private intl: IntlService) {


  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {


  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.doituongSelect.KBNN_Ten = null;
    }
    else
      this.doituongSelect.KBNN_Ten = $event.Ten_Doi_Tuong;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;

  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);
      this.donviid = this.currentUser.id_don_vi;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    this.nhomdtid = nhomdoituongid;
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);


    //this.repo.getRequest("api/hoso/conmonlist/", { entityName: "DM_CapDonVi" })
    //  .subscribe(response => {
    //    this.inputCapDonVis = response;
    //  });
    this.inputCapDonVis = [{ Id: 0, Ten: 'Cấp Tổng cục' }, { Id: 1, Ten: 'Cấp Cục' }, { Id: 2, Ten: 'Cấp Chi Cục' }]
    this.doituongSelect = {
      Id: null, Ma: null, Ten: null, DiaChi: null, DienThoai: null, Email: null, MaAo: null,
      CapTrenId: null, TenTiengNuocNgoai: null, SapXep: null
      , Created: null, CreatedBy: null, Modified: null, ModifiedBy: null
      , VungId: null, ThuocCap: null, NgayThanhLap_S: null, NgayGiaiThe_S: null, NgayGiaiThe: null, NgayThanhLap: null
    };   

    if (id === null || id === '0') {
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      this.repo.postRequest("api/donvi/getall/", { Id: null, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputparents = response;
        });
    }
    else {

      this.repo.postRequest("api/donvi/getall/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputparents = response;
        });

      let data1 = { Id: id, PhanHeId: nhomdoituongid };
      //console.log("donvisudung lig");
      //console.log(data1);
      //console.log("donvisudung lig2");

      this.repo.postRequest("api/donvi/getbyid/", data1)
        .subscribe(response => {

          if (response.NgayThanhLap != null)
            this.doituongSelect.NgayThanhLap = new Date(response.NgayThanhLap);
          else
            this.doituongSelect.NgayThanhLap = null;
          if (response.NgayGiaiThe != null)
            this.doituongSelect.NgayGiaiThe = new Date(response.NgayGiaiThe);
          else
            this.doituongSelect.NgayGiaiThe = null;

          this.doituongSelect.Id = id;
          this.doituongSelect.Ma = response.Ma;
          this.doituongSelect.Ten = response.Ten;
          this.doituongSelect.DiaChi = response.DiaChi;
          this.doituongSelect.DienThoai = response.DienThoai;
          this.doituongSelect.NgayThanhLap_S = response.NgayThanhLap_S;
          this.doituongSelect.NgayGiaiThe_S = response.NgayGiaiThe_S;
          this.doituongSelect.Email = response.Email;
          this.doituongSelect.MaAo = response.MaAo;
          this.doituongSelect.VungId = response.VungId;
          this.doituongSelect.ThuocCap = response.ThuocCap;
          this.doituongSelect.CapTrenId = response.CapTrenId;
          this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;
          this.doituongSelect.SapXep = response.SapXep;
          this.doituongSelect.Created = response.Created;
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;

          //this.doituongSelect.SapXep = response.SapXep;
          //this.doituongSelect.Created = response.Created;
          //this.doituongSelect.CreatedBy = response.CreatedBy;
          //this.doituongSelect.Modified = new Date();
          //this.doituongSelect.ModifiedBy = this.currentUser.user_name;

        });
    }


  }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {

    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }

  }
  keyTenPress(event: any) {
    if (event.which === 13) {
      // this.slLoaiTaiSan.focus();
      event.preventDefault();
    }
  }
  keySoTKPress(event: any) {
    if (event.which === 13) {
      this.inputTenKB.focus();
      event.preventDefault();
    }
  }

  public onNgayThayDoiChange(value: Date) {
    // Update the JSON birthDate string date
    this.doituongSelect.NgayThanhLap_S = this.intl.formatDate(value, 'dd/MM/yyyy');
  }
  public onNgayKetThucChange(value: Date) {
    // Update the JSON birthDate string date
    this.doituongSelect.NgayGiaiThe_S = this.intl.formatDate(value, 'dd/MM/yyyy');
  }

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.Ma == null || this.doituongSelect.Ma == "") {
      swal('Lỗi!', 'Vui lòng nhập mã trung tâm!.', 'error');
      return;
    }
    if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
      swal('Lỗi!', 'Vui lòng nhập tên trung tâm!.', 'error');
      return;
    }


    this.repo.postRequest("api/donvi/addorupdate", this.doituongSelect)
      .subscribe(response => {
        if (response == 0 || (response != null && parseInt(response))) {
          if (response > 0)
            this.doituongSelect.Id = parseInt(response);
          this.save.emit(this.doituongSelect);
        }
        else {
          swal('Lỗi!', response, 'error');
        }

      });
  }

  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent) {

    this.comboSeleted = cobo;
    cobo.close();
    this.doituongchungedit.loadDataInit(Ultil_donvi.id, null, this.donviid);

  }
  saveModal(doituong: any) {
    console.log(doituong);

    this.comboSeleted.focus();
  }



}


